export default {"src":"/_next/static/media/arrow_left.3b04cc64.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};